type Account = {
    __typename: string;
    id: string;
    firstName: string;
    lastName: string;
    isOrganizationAdmin: boolean;
    isAdiAdmin: boolean;
    isSuperAdmin: boolean | null;
    isTeacher: boolean;
    isStudent: boolean;
    isAssistant: boolean;
    isBookUser: boolean;
  };
  
  export const generateCSVFromAccounts = (accounts: any[], filename = 'accounts.csv') => {
    if (!accounts.length) return;
  
    const headers = Object.keys(accounts[0]);
    const rows = accounts.map((account) =>
      headers.map((header) => {
        const value = account[header as keyof Account];
        return typeof value === 'boolean' || typeof value === 'number' ? value : `"${value ?? ''}"`;
      }).join(',')
    );
  
    const csvContent = [headers.join(','), ...rows].join('\n');
  
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  